'use client';

import { memo, useEffect } from 'react';
import { useInViewport } from '@mantine/hooks';

interface InViewportProps {
  className?: string;
  onInViewport: () => void;
  isActive: boolean;
}

export const InViewport = memo(
  ({ className, onInViewport, isActive }: InViewportProps) => {
    const { ref, inViewport } = useInViewport();

    useEffect(() => {
      if (inViewport && isActive) {
        onInViewport();
      }
    }, [inViewport, isActive, onInViewport]);

    return <div className={className} ref={ref} />;
  }
);

InViewport.displayName = 'InViewport';
